import Vue from "vue";
import * as Klaro from "klaro/dist/klaro-no-css";
export default Vue.extend({
    name: "CookieCompliance",
    data() {
        return {
            alreadyConsented: false,
            infoAccordionOpen: false,
            purposes: {
                essential: true,
                statistics: false,
            },
            config: {
                lang: "de",
                mustConsent: true,
                translations: {
                    de: {
                        googleAnalytics: {
                            title: "Google Analytics",
                            description: "The analytics service ran by a most definitely non-evil company.",
                            purpose: ["statistics"],
                        },
                        purposes: {
                            essential: "Notwendig",
                            statistics: "Statistik",
                        },
                    },
                },
                apps: [
                    {
                        name: "analytics",
                        purposes: ["statistics"],
                        cookies: ["_gid", "_ga", "_gat_gtag_UA_6361805_30"]
                    },
                ],
            },
        };
    },
    computed: {
        manager() {
            return Klaro.getManager(this.config);
        },
    },
    watch: {
        alreadyConsented(consented) {
            this.setOverflow(consented);
        },
    },
    created() {
        this.alreadyConsented = this.manager.confirmed;
        this.setOverflow(this.alreadyConsented);
        for (const purpose in this.purposes) {
            const purposeApps = this.getApps(purpose);
            purposeApps.forEach((app) => {
                const consent = this.manager.getConsent(app.name);
                this.purposes[purpose] = consent;
            });
        }
        Vue.prototype.$editCookiePreferences = () => {
            this.alreadyConsented = false;
        };
    },
    mounted() {
        Klaro.renderKlaro(this.config, false);
    },
    methods: {
        acceptPreferences() {
            for (const purpose in this.purposes) {
                const purposeApps = this.getApps(purpose);
                const state = this.purposes[purpose];
                purposeApps.forEach((app) => {
                    this.manager.updateConsent(app.name, state);
                });
            }
            this.manager.saveAndApplyConsents();
            this.alreadyConsented = true;
        },
        acceptAll() {
            this.toggleAll(true);
        },
        declineAll() {
            this.toggleAll(false);
        },
        toggleAll(state) {
            this.manager.changeAll(state);
            this.manager.saveAndApplyConsents();
            for (const purpose in this.purposes) {
                this.purposes[purpose] = state;
            }
            this.alreadyConsented = true;
        },
        getApps(purpose) {
            const apps = this.config.apps;
            return apps.filter((app) => app.purposes.includes(purpose));
        },
        setOverflow(consented) {
            if (consented) {
                document.body.classList.remove("overflow-hidden");
            }
            else {
                document.body.classList.add("overflow-hidden");
            }
        },
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/components/CookieCompliance/CookieCompliance.ts
// module id = null
// module chunks = 